import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getProducts, getCompanySettings } from '../services/api';

const bgClasses = ['p1','p2','p3','p4','p5','p6'];
const defaultIcons = ['⚙️','🔩','🏗️','🔧','⚡','🏭'];

const Products = () => {
  const sectionRef = useRef(null);
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [ready, setReady] = useState(false);
  const [sectionTag, setSectionTag] = useState('Component Products');
  const [sectionHeading, setSectionHeading] = useState('Our Products');
  const [sectionDesc, setSectionDesc] = useState('');

  useEffect(() => {
    getCompanySettings().then(data => {
      if (data) {
        if (data.products_tag) setSectionTag(data.products_tag);
        if (data.products_heading) setSectionHeading(data.products_heading);
        if (data.products_description) setSectionDesc(data.products_description);
      }
    });
    getProducts({ per_page: 8, category: "components", featured: true }).then(data => {
      if (data && data.length > 0) {
        const mapped = data.map((p, i) => ({
          id: p.id,
          name: p.name,
          slug: p.slug,
          desc: p.short_description || p.description || '',
          cat: [p.category?.name, p.brand?.name, p.type_unit?.name].filter(Boolean).join(' · ') || 'Product',
          quantity: p.quantity ?? 0,
          image: p.primary_image_url || null,
          icon: defaultIcons[i % defaultIcons.length],
          bg: bgClasses[i % bgClasses.length],
        }));
        setProducts(mapped);
      }
      setReady(true);
    }).catch(() => setReady(true));
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => entries.forEach(e => { if(e.isIntersecting) e.target.classList.add('visible'); }),
      { threshold: 0.1, rootMargin: '0px 0px -30px 0px' }
    );
    const els = sectionRef.current.querySelectorAll('.rv');
    els.forEach(el => observer.observe(el));
    return () => els.forEach(el => observer.unobserve(el));
  }, [products]);

  const handleInquire = (e, product) => {
    e.preventDefault();
    const message = `Hello AFS, I am interested in the following product:\nName Component: ${product.name}\nPlease send me more information. Thank you.`;
    sessionStorage.setItem('contact_prefill', JSON.stringify({
      subject: 'Product Inquiry',
      message,
    }));
    navigate('/contact');
  };

  return (
    <section id="products" ref={sectionRef} style={{ opacity: ready ? 1 : 0, transition: 'opacity 0.3s ease' }}>
      <div className="wrap">
        <div className="prod-hdr">
          <div className="rv">
            <div className="slide-index" style={{color:"var(--yd)"}}><span></span> {sectionTag}</div>
            <h2 className="heading">{(() => {
              const words = sectionHeading.split(' ');
              if (words.length >= 2) return <>{words.slice(0, -1).join(' ')} <em>{words[words.length - 1]}</em></>;
              return <em>{sectionHeading}</em>;
            })()}</h2>
            {sectionDesc && <p style={{color:'var(--mid)',fontSize:'15px',lineHeight:'1.75',marginTop:'14px',maxWidth:'600px',display:'-webkit-box',WebkitLineClamp:2,WebkitBoxOrient:'vertical',overflow:'hidden'}}>{sectionDesc}</p>}
          </div>
          <a href="/components" className="btn btn-dark rv">See All Components ↗</a>
        </div>
        <div className="prod-grid">
          {products.map((p, i) => (
            <div className={`prod-card rv d${(i % 3) + 1}`} key={p.id || i}>
              <div className="pc-img-wrap">
                <span className="pc-badge-stock">Stock: {p.quantity}</span>
                {p.image ? (
                  <img src={p.image} alt={p.name} className="pc-img" />
                ) : (
                  <div className={`pc-img ${p.bg}`}>{p.icon}</div>
                )}
                <div className="pc-overlay"><a href="/contact" onClick={(e) => handleInquire(e, p)}>Inquire Now ↗</a><a href={`/components/${p.slug}`}>Detail</a></div>
              </div>
              <div className="pc-body">
                <span className="pc-cat">{p.cat}</span>
                <div className="pc-name">{p.name}</div>
                
                
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Products;
